/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  API_CHANGE_PASSWORD,
  API_DELETE_FILE,
  API_FORGET_PASS,
  API_GET_GYOSHU_MST,
  API_GET_ME,
  API_GET_MEISHO_MST,
  API_GET_MITSUMORI_TANKA,
  API_GET_NENDO,
  API_GET_SELECT_ORDER_NO,
  API_GET_SHIIRE_TANKA,
  API_GET_SHOHIZEI_MST,
  API_GET_SHUKASAKI_SOKO,
  API_GET_SOSHIKI_MST,
  API_GET_MENU_PTN,
  API_GET_SYSDATE,
  API_GET_UCHIWAKE_CALC,
  API_GET_WARIATE_INFO,
  API_GET_ZAIKO_INFO,
  API_LOGIN,
  API_N_040JUC,
  API_ONLINE_CHECK,
  API_SAITO_CALC,
  API_SEARCH_MENU_ADDRESS,
  API_SEARCH_SHIIRESAKI,
  API_SEARCH_TOKUISAKI,
  API_UPLOAD_FILE,
  API_UPLOAD_FILE_2,
  API_DOWNLOAD_FILE,
  API_EIGYO_YMD_CHECK,
  API_SEARCH_G_SHUKASAKI_SOKO,
  API_SEARCH_NOHINSAKI,
  API_G_DOWNLOAD_FILE,
  API_GET_BESSHI_TEMP,
  API_GET_SYSTEM_DATETIME,
} from '@/constants/api';
import { MeishoBunruiCd, OutStatus, UmuFlg } from '@/constants/constants';
import { HOME } from '@/constants/label';
import axios from '@/plugins/axios';
import router from '@/router';
import {
  headerInfoType,
  IMenuItem,
  saitoCalcType,
  UserInfoType,
} from '@/types/common';
import { getMessageInfo } from '@/utils/message';
import { Core, PdfExport } from '@grapecity/activereports';
import { PageReport } from '@grapecity/activereports/core';
import type { Module } from 'vuex';
Core.setLicenseKey(process.env.VUE_APP_ACTIVE_REPORTS_LICENCE);

type Common = {
  auth: boolean;
  token: string;
  menu: IMenuItem[];
  userInfo: UserInfoType;
  messageID: string;
  messageArgs: string[];
  messageType: '' | 'info' | 'warning' | 'error';
  message: string;
  errorCode: string;
  outStatus: number;
  headerInfo: headerInfoType;
  childHeaderTitle: string;
  saitoCalc: saitoCalcType;
  shiireTanka: number;
  changePassswordRequired: boolean;
  isLoading: boolean;
  shohizeiMstList: any[];
  gyoshuMstList: any[];
};

const common: Module<Common, unknown> = {
  namespaced: true,
  state: {
    auth: Boolean(sessionStorage.getItem('Authorization')),
    token: '',
    menu: [],
    userInfo: {},
    messageID: '',
    messageArgs: [],
    messageType: '',
    message: '',
    errorCode: '',
    outStatus: OutStatus.NORMAL,
    headerInfo: {},
    childHeaderTitle: '',
    saitoCalc: {},
    shiireTanka: 0,
    changePassswordRequired: false,
    isLoading: false,
    shohizeiMstList: [],
    gyoshuMstList: [],
  },
  mutations: {
    SET_AUTH(state, payload) {
      state.auth = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
    SET_MENU(state, payload) {
      state.menu = payload;
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    },
    SET_CHANGE_PASSWORD(state, payload) {
      state.changePassswordRequired = payload;
    },
    SET_MESSAGE_ID(state, payload) {
      state.messageID = payload;
    },
    SET_MESSAGE_ARGS(state, payload) {
      state.messageArgs = payload;
    },
    SET_MESSAGE_TYPE(state, payload) {
      state.messageType = payload;
    },
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    SET_ERROR_CODE(state, payload) {
      state.errorCode = payload;
    },
    SET_OUT_STATUS(state, payload) {
      state.outStatus = payload;
    },
    SET_HEADER_INFO(state, payload) {
      state.headerInfo = payload;
    },
    SET_CHILD_HEADER_TITLE(state, payload) {
      state.childHeaderTitle = payload;
    },
    SET_SAITO_CALC(state, payload) {
      state.saitoCalc = payload;
    },
    SET_SHIIRE_TANKA(state, payload) {
      state.shiireTanka = payload;
    },
    SET_IS_LOADING(state, payload: boolean) {
      state.isLoading = payload;
    },
    SET_SHOHIZEI_MST_LIST(state, payload) {
      state.shohizeiMstList = payload;
    },
    SET_GYOSHU_MST_LIST(state, payload) {
      state.gyoshuMstList = payload;
    },
  },
  getters: {
    auth: (state) => state.auth,
    menu: (state) => state.menu,
    userInfo: (state) => state.userInfo,
    messageID: (state) => state.messageID,
    messageArgs: (state) => state.messageArgs,
    messageType: (state) => state.messageType,
    message: (state) => state.message,
    errorCode: (state) => state.errorCode,
    outStatus: (state) => state.outStatus,
    headerInfo: (state) => state.headerInfo,
    childHeaderTitle: (state) => state.childHeaderTitle,
    saitoCalc: (state) => state.saitoCalc,
    shiireTanka: (state) => state.shiireTanka,
    changePassswordRequired: (state) => state.changePassswordRequired,
    isLoading: (state) => state.isLoading,
    shohizeiMstList: (state) => state.shohizeiMstList,
    gyoshuMstList: (state) => state.gyoshuMstList,
  },
  actions: {
    async login({ commit }, params) {
      const res = await axios.post(API_LOGIN, params);
      if (!res) {
        return;
      }
      const { token } = res.data;
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        sessionStorage.setItem('Authorization', token);
        commit('SET_AUTH', true);
        commit('SET_TOKEN', token);
        commit('SET_MESSAGE_ID', '');
        commit('SET_MESSAGE_ARGS', []);
        commit('SET_MESSAGE_TYPE', '');
        commit('SET_MESSAGE', '');
        commit('SET_ERROR_CODE', '');
        commit('SET_OUT_STATUS', OutStatus.NORMAL);

        // パスワード強制変更
        if (res.data.passwordChange === 1) {
          // index.vue で遷移するので、ここで changePassswordRequired にセットする
          commit('SET_CHANGE_PASSWORD', true);
        }
        router.push('/');
      }
    },
    async searchUser(_ctx, params) {
      // 20221111 nagino パスワード変更時のユーザー存在チェックはしない仕様に変更
      // //userId が存在するか確認する API
      // const res = await axios.get(API_SEARCH_USER, params);

      // //200 か 204 であれば ID が存在するので、[パスワード忘れた場合] 画面に遷移する
      // if (
      //   res &&
      //   (res.status === STATUS_CODE.OK || res.status === STATUS_CODE.NO_CONTENT)
      // ) {
      router.push({
        name: 'ForgotPassword',
        params: { userId: params.params.user },
      });
      // }
    },
    async getMe({ commit }) {
      const user = await axios.post(API_GET_ME);
      if (!user) {
        return;
      }
      const { data } = user;
      commit('SET_MENU', data.responseData.menuData);
      commit('SET_USER_INFO', data.responseData);
      sessionStorage.setItem(
        'GenzaiYmd',
        data.responseData.onlineData.genzaiYmd
      );
      sessionStorage.setItem('RiyoshaCd', data.responseData.riyoshaCd);
      if (data.responseData.kainaiKaigaiKb) {
        commit('SET_HEADER_INFO', {
          title: HOME.HEADER_TITLE_KAIGAI,
          helpUrl: '',
          hikisuInfo: '',
        });
      } else {
        commit('SET_HEADER_INFO', {
          title: HOME.HEADER_TITLE_KAINAI,
          helpUrl: '',
          hikisuInfo: '',
        });
      }
    },
    async changePassword({ dispatch, commit }, params) {
      // パスワード変更API
      const res = await axios.put(API_CHANGE_PASSWORD, params);

      const { error } = res.data;
      if (error === undefined) {
        dispatch('logout');
        return;
      }
      if (
        error.outStatus === OutStatus.CHECK_ERR ||
        error.outStatus === OutStatus.EXCLUSIVE_ERR
      ) {
        commit('SET_MESSAGE_ID', error.messageID);
        commit('SET_MESSAGE_ARGS', error.messageArgs);
        commit('SET_OUT_STATUS', error.outStatus);
        const info = getMessageInfo(error.messageID, error.messageArgs);
        commit('SET_MESSAGE_TYPE', info.messageType);
        commit('SET_MESSAGE', info.messageText);
      } else {
        dispatch('logout');
      }
    },
    async forgetPassword(_ctx, params) {
      // 仮パスワード発行API
      return await axios.post(API_FORGET_PASS, params);
    },
    async onlineCheck(_ctx, params) {
      // 共通関数API.オンライン状況チェックを呼び出す。
      await axios.get(
        `${API_ONLINE_CHECK}/${params.jigyoshoCd}/${params.targetYmd}`
      );
    },
    async getChildHeaderTitle({ commit }, params) {
      await axios
        .get(API_GET_MEISHO_MST, {
          params: {
            meishoBunruiCd: MeishoBunruiCd.SHORI_TITLE,
            meishoCd: params.shoriKb,
            mukoUmuFlg: UmuFlg.NASHI,
          },
        })
        .then((res) => {
          if (res.data.responseData && res.data.responseData.length > 0) {
            commit(
              'SET_CHILD_HEADER_TITLE',
              res.data.responseData[0].meishoMei
            );
          }
        });
    },
    async getNendo(_ctx, params) {
      return axios.get(API_GET_NENDO, {
        params,
      });
    },
    async wariateInfo(_ctx, params: any) {
      return axios.get(API_GET_WARIATE_INFO, {
        params,
      });
    },
    async getMeishoMst(_ctx, params: any) {
      return axios.get(API_GET_MEISHO_MST, {
        params,
      });
    },
    async getMeishoMaster({ commit }, params) {
      const res = await axios({
        url: API_GET_MEISHO_MST,
        params,
        method: 'GET',
      });
      const { responseData } = res.data;
      if (responseData) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const list = responseData.map((item: any) => {
          item.meishoCd = +item.meishoCd;
          return item;
        });
        commit('SET_MEISHO_MST_LIST', list);
      } else {
        commit('SET_MEISHO_MST_LIST', []);
      }
    },
    async getShohizeiMaster({ commit }, params) {
      const res = await axios({
        url: API_GET_SHOHIZEI_MST,
        params,
        method: 'GET',
      });
      const { responseData } = res.data;
      if (responseData) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const list = responseData.map((item: any) => {
          item.meishoCd = +item.meishoCd;
          return item;
        });
        commit('SET_SHOHIZEI_MST_LIST', list);
      } else {
        commit('SET_SHOHIZEI_MST_LIST', []);
      }
    },
    async getGyoshuMaster({ commit }, params) {
      const res = await axios({
        url: API_GET_GYOSHU_MST,
        params,
        method: 'GET',
      });
      const { responseData } = res.data;
      if (responseData) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const list = responseData.map((item: any) => {
          item.meishoCd = +item.meishoCd;
          return item;
        });
        commit('SET_GYOSHU_MST_LIST', list);
      } else {
        commit('SET_GYOSHU_MST_LIST', []);
      }
    },
    async getGyoshuMst(_ctx, params: any) {
      return axios.get(API_GET_GYOSHU_MST, {
        params,
      });
    },
    async getZaikoInfo(_ctx, params: any) {
      return axios.get(API_GET_ZAIKO_INFO, {
        params,
      });
    },
    async getWariateInfo({ dispatch }, params) {
      const resNendo = await dispatch('getNendo', {
        targetYmd: params.targetYmd,
      });
      delete params.targetYmd;
      const wariateParams = {
        ...params,
        nendo: resNendo.data.nendo,
      };
      return await dispatch('wariateInfo', wariateParams);
    },
    async getZaikoInfoAndWariateInfo({ dispatch }, params) {
      const resZaikoInfo = await dispatch('getZaikoInfo', params.zaikoParams);
      const { miNyukoSuryo, genZaikoSuryo } = resZaikoInfo.data.responseData;
      const resWariateInfo = await dispatch(
        'getWariateInfo',
        params.wariateParams
      );
      const { hatchuSuryo, wariateSuryo } = resWariateInfo.data.responseData;
      return { hatchuSuryo, wariateSuryo, miNyukoSuryo, genZaikoSuryo };
    },
    async getShukasakiSoko(_ctx, params: any) {
      return axios.get(API_GET_SHUKASAKI_SOKO, {
        params,
      });
    },
    async getMitsumoriTanka(_ctx, params: any) {
      return axios.get(API_GET_MITSUMORI_TANKA, {
        params,
      });
    },
    async getSoshikiMst(_ctx, params: any) {
      return axios.get(API_GET_SOSHIKI_MST, {
        params,
      });
    },
    async getMenuPtn(_ctx, params: any) {
      return axios.get(API_GET_MENU_PTN, {
        params,
      });
    },
    async uchiwakeCalc(_ctx, params: any) {
      return axios.post(
        API_GET_UCHIWAKE_CALC,
        { requestData: params.requestBody.requestData },
        {
          params: params.queryParams,
        }
      );
    },
    async saitoCalc(_ctx, params: any) {
      return axios.get(API_SAITO_CALC, {
        params,
      });
    },
    async eigyoYmdCheck(_ctx, params: any) {
      return axios.get(API_EIGYO_YMD_CHECK, {
        params,
      });
    },
    async getOrderNo(_ctx, params: any) {
      return axios.get(API_GET_SELECT_ORDER_NO, {
        params,
      });
    },
    async getMenuAddressItem(_ctx, params: any) {
      return axios.get(API_SEARCH_MENU_ADDRESS, {
        params,
      });
    },
    async getJuchuListOut(_ctx, params: any) {
      return axios.get(API_N_040JUC, {
        params,
      });
    },
    async getShiiresaki(_ctx, params: any) {
      return axios.get(API_SEARCH_SHIIRESAKI, {
        params,
      });
    },
    async getShohizeiMst(_ctx, params: any) {
      return axios.get(API_GET_SHOHIZEI_MST, {
        params,
      });
    },
    async getTokuisakiMst(_ctx, params: any) {
      return axios.get(API_SEARCH_TOKUISAKI, {
        params,
      });
    },
    async getNohinsakiMst(_ctx, params: any) {
      return axios.get(API_SEARCH_NOHINSAKI, {
        params,
      });
    },
    // eslint-disable-next-line
    async getSysdate(_ctx) {
      return axios.get(API_GET_SYSDATE);
    },
    setHeaderInfo({ commit }, params) {
      commit('SET_HEADER_INFO', params);
    },
    // テスト用コマンド
    downloadPDF(pdf: any) {
      // const linkSource = `data:application/pdf;base64,${pdf}`;
      const linkSource = `${pdf}`;
      const downloadLink = document.createElement('a');
      const fileName = 'abc.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },

    // test start--------------------------------------------------
    // async exportOrder(e:any) {
    //   const newReport = new PageReport({ language: 'jp' });
    //   const data = await e;

    //   const doc = await newReport
    //     .load(this.reportData)
    //     //        .then(() => newReport.run());
    //     .then(() => {
    //       newReport.parameters['dataString'].values = [JSON.stringify(data)];
    //       return newReport.run();
    //     });
    //   PdfExport.exportDocument(doc, {
    //     info: {
    //       title: 'N_Uri010_UriageEntry_Test_PDF',
    //     },
    //   })
    //     .then((result) => {
    //       result.download('N_Uri010_UriageEntry_Test_PDF');
    //     })
    //     .catch(console.error);
    // },
    // test end--------------------------------------------------

    async generateBase64PDFArray(_ctx, params) {
      // eslint-disable-next-line
      // @ts-ignore
      const base64Array = [];
      // eslint-disable-next-line
      // @ts-ignore
      let tmpReport;
      for (let index = 0; index < params.reportData.length; index++) {
        // テンプレートの取得
        const reportResponse = await fetch(params.templateURL[index]);
        const report = await reportResponse.json();
        // データ入力
        report.DataSources[0].ConnectionProperties.ConnectString =
          'jsondata=' + params.reportData[index];
        tmpReport = report;
        const report2 = new PageReport({ language: 'jp' });
        // const doc = await report2.load(tmpReport).then(() => report.run());
        const doc = await report2.load(tmpReport).then(() => {
          report2.parameters['dataString'].values = [params.reportData[index]];
          return report2.run();
        });
        console.log(doc);
        await PdfExport.exportDocument(doc, {
          info: {
            title: params.pdfFileName[index],
            subject: params.pdfFileName[index],
          },
        })
          .then((result) => {
            return new Promise((resolve) => {
              const reader = new FileReader();
              // blob を base64 へ変換
              reader.readAsDataURL(result.data);
              reader.onloadend = () => {
                resolve(base64Array.push(reader.result));
              };
            });
          })
          .catch(console.error);
      }
      // eslint-disable-next-line
      // @ts-ignore
      return base64Array;
    },

    downloadFile(_ctx, params) {
      return axios({
        url: API_DOWNLOAD_FILE,
        params: params,
        method: 'GET',
      });
    },

    gDownloadFile(_ctx, params) {
      return axios({
        url: API_G_DOWNLOAD_FILE,
        params: params,
        method: 'GET',
      });
    },

    async uploadFile(_ctx, reqObj) {
      return await axios({
        url: API_UPLOAD_FILE,
        data: reqObj,
        method: 'POST',
      });
    },

    async uploadFile2(_ctx, reqObj) {
      return await axios({
        url: API_UPLOAD_FILE_2,
        data: reqObj,
        method: 'POST',
      });
    },

    async deleteFile(_ctx, params) {
      return await axios({
        url: API_DELETE_FILE,
        params: params,
        method: 'DELETE',
      });
    },

    setMessage({ commit }, errorInfo) {
      if (errorInfo.error) {
        const { messageID, messageArgs, outStatus } = errorInfo.error;
        commit('SET_MESSAGE_ID', messageID);
        commit('SET_MESSAGE_ARGS', messageArgs);
        commit('SET_OUT_STATUS', outStatus);
        const info = getMessageInfo(messageID, messageArgs);
        commit('SET_MESSAGE_TYPE', info.messageType);
        commit('SET_MESSAGE', info.messageText);
      }
      commit('SET_ERROR_CODE', errorInfo.status);
    },
    resetMessage({ commit }) {
      commit('SET_MESSAGE_ID', '');
      commit('SET_MESSAGE_ARGS', []);
      commit('SET_MESSAGE_TYPE', '');
      commit('SET_MESSAGE', '');
      commit('SET_ERROR_CODE', '');
      commit('SET_OUT_STATUS', OutStatus.NORMAL);
    },
    logout() {
      sessionStorage.clear();
      //login 情報を clear したので、reload できずに login に遷移する
      document.location.reload();
    },
    // サイト算出
    async getSaitoCalc({ commit }, params) {
      const res = await axios({
        params: params,
        url: API_SAITO_CALC,
        method: 'GET',
      });
      const { responseData } = res.data;
      commit('SET_SAITO_CALC', responseData);
    },
    // 仕入単価取得
    async getShiireTanka({ commit }, params) {
      const res = await axios({
        params: params,
        url: API_GET_SHIIRE_TANKA,
        method: 'GET',
      });
      const { shiireTanka } = res.data;
      commit('SET_SHIIRE_TANKA', Number(shiireTanka));
    },
    resetShiireTanka({ commit }) {
      commit('SET_SHIIRE_TANKA', 0);
    },
    setIsLoading({ commit }, flg) {
      commit('SET_IS_LOADING', flg);
    },
    async getGShukasakiSoko(_ctx, params: any) {
      return axios.get(API_SEARCH_G_SHUKASAKI_SOKO, {
        params,
      });
    },
    // 別紙添付参照
    getBesshiTemp(_ctx, params: any) {
      return axios.get(API_GET_BESSHI_TEMP, {
        params,
      });
    },
    // システム日時取得
    async getSystemDateTime(_ctx: any) {
      return axios.get(API_GET_SYSTEM_DATETIME);
    },
  },
};

export default common;
